export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13689.59497942.jpg";